<template>
  <v-btn
    v-if="activeAccount"
    class="active-account-btn d-flex align-center pa-1 rounded-lg"
    variant="tonal"
    :active="false"
    :to="{ name: ROUTE_ACCOUNT_DETAILS, params: { address: activeAccount } }"
  >
    <div class="py-1 px-1 px-lg-2 px-xl-3 address-btn">
      <div class="d-flex align-center account-address">
        <AddressAvatar :address="activeAccount" :size="26" />

        <span class="d-none d-lg-inline ml-1 ml-lg-2">
          {{ formatAddress(activeAccount) }}
        </span>
      </div>
    </div>

    <div class="d-flex ga-1 align-center pl-2 pl-lg-3 pr-2 balance">
      <v-progress-circular
        v-if="isBalanceStillLoading"
        size="18"
        width="2"
        indeterminate
      />
      <template v-else>
        <span v-if="smAndDown" v-text="aeBalance?.shorten()" />
        <FractionFormatter
          v-else
          :fractional-price="formatFractionalPrice(aeBalance)"
        />
        {{ AETERNITY_SYMBOL }}
      </template>
    </div>
  </v-btn>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useDisplay } from "vuetify";

import { AETERNITY_SYMBOL, ROUTE_ACCOUNT_DETAILS } from "@/utils/constants";
import { formatAddress, formatFractionalPrice } from "@/utils";
import { useAeBalance, useWalletConnect } from "@/composables";
import { useAccounts } from "@/stores";

import AddressAvatar from "@/components/Common/AddressAvatar.vue";
import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";

const { smAndDown } = useDisplay();
const { activeAccount } = storeToRefs(useAccounts());
const { scanningForAccounts } = useWalletConnect();

const { aeBalance, aeBalanceLoaded, aeBalanceLoading } = useAeBalance();

const isBalanceStillLoading = computed(
  () =>
    scanningForAccounts.value ||
    (aeBalanceLoading.value && !aeBalanceLoaded.value)
);
</script>

<style lang="scss" scoped>
.active-account-btn {
  height: auto;
  font-family: inherit !important;

  .address-btn {
    min-width: 0;
    height: auto !important;
    background: rgba(white, 0.1);
    border-radius: 12px;
  }

  .account-address {
    .avatar {
      width: 26px;
      height: 26px;
    }
  }

  .balance {
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0 !important;
  }

  @media screen and (max-width: 1400px) {
    .balance {
      font-size: 14px;
    }
  }
}
</style>
